import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromSession from '../reducers/session.reducer';
import { AuthService } from '../../shared/services/auth.service';
import { OAuthService, OAuthEvent } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {


  @ViewChild('drawer', null) sidenav:any;

  public fullname: string = '';
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showMenu: boolean = true;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver,
  	private store: Store<any>,
  	private authService: OAuthService) {}

  ngOnInit() {

  }

  logout() {
  	this.authService.logOut();
    setTimeout(() => {
        window.location.href = 'https://idp.jklm.be/oauth2/logout?client_id=036775cb-1adf-4735-90cf-99ca9e4d5105';
    },500);
  }
  toggleSideNav() {
      this.sidenav.toggle();
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }
}
